var Pixel = Pixel || {};

Pixel.DCApiWrapper = (function () {
	var DCApi = function(opts) {
		opts = opts || {};
		opts.id && (this._id = opts.id);
		opts.isMobile && (this._isMobile = opts.isMobile);
		opts.countryID && (this._countryID = opts.countryID);
		opts.getLangID && (this._getLangID = opts.getLangID);
	};

	_.extend(DCApi.prototype, {
		trackCategory: function(cat) {
			var axel = Math.random() + '',
				a = axel * 10000000000000;
			var type = this._getType(this._isMobile ? 'mob' : 'web');
			this._insertIframe('https://' + this._id + '.fls.doubleclick.net/activityi;src=' + this._id + ';type=' + type + ';cat=' + cat + ';u1=' + document.location.href + ';u2=' + this._getLangID() + ';ord=' + a + '?');
		},

		trackPurchase: function (orderNo, totalPrice, totalQty, productIDs, prices, orderID, revenue) {
			var type = this._getType(this._isMobile ? 'mc' : 'wc');
			this._insertIframe('https://' + this._id + '.fls.doubleclick.net/activityi;src=' + this._id + ';type=' + type + ';cat=checkout;qty=1;cost=' + revenue + ';u2=' + this._getLangID() + ';u3=' + orderNo + ';u4=' + totalPrice + ';u5=' + totalQty + ';u6=' + productIDs + ';u7=' + prices + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + orderID + '?');
		},

		_insertIframe: function(url) {
			var iframe = document.createElement('iframe');
			iframe.setAttribute('src', url);
			iframe.setAttribute('width', '1');
			iframe.setAttribute('height', '1');
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('class', 'iframe-counter');
			iframe.style.display = 'none';
			document.body.appendChild(iframe);
		},

		_getType: function(prefix) {
			return prefix + this._countryID.toLowerCase();
		},

		_getLangID: function() {
			return null;
		},

		_isMobile: false
	});

	return DCApi;
})();

Pixel.DC = (function (PixelBase) {
	var DC = PixelBase.extend({
		registrationView: function () {
			this._api.trackCategory('signup');			
		},

		registrationSuccess: function () {
			this._api.trackCategory('join');			
		},

		purchaseSuccess: function (opts) {
			opts = opts || {};
		    this._api.trackPurchase(opts.orderNo, opts.totalValue, opts.totalQty, opts.productIDs, opts.prices, opts.paymentID, opts.revenue);
		}
	});

	return DC;
})(Pixel.PixelBase);

!function (Pixel, app, GlobalSettings) {
    if (!GlobalSettings.DCE) {
		return;
	}

	new Pixel.DC({
		api: new Pixel.DCApiWrapper({
			isMobile: true,
			id: GlobalSettings.DCI,
			countryID: GlobalSettings.Country.ID,
			getLangID: function() {
                return app.cookie.getUserLanguage();
			}
		})
	});
}(Pixel, app, GlobalSettings);
